import Api from '@/api'
import Vue from 'vue'

// QUITAMOS DISEASES Y OUTPUTS PORQUE DE MOMENTO NO VAN...
let optionsType= [
  'populations',
  'diseases',
  'treatments',
  // 'outputs'
]

let typeToList = {
  'populations': 'parameters',
  'diseases': 'diseases',
  'treatments': 'treatments',
  'outputs': 'outputs'
}
export default {
  namespaced: true,
  state: {
    data: {},
    loaded: false,
    optionsType: optionsType
  },
  getters: {
    getById: (state) => () => {
    }
  },
  actions: {
    // TODO Synch all calls
    loadAll ({state, commit}, params) {
      commit('setLoaded', false)
      let calls = []
      optionsType.forEach(optionKey => {
        calls.push(Api.getDefinitionList(optionKey).then(res => {
          commit('setOptionList', {key: typeToList[optionKey], data:res})
        }))
      })
      Promise.all(calls).then((vals) => {
        commit('setLoaded', true)
      })

    }
  },
  mutations: {
    setOptionList (state, {key, data}) {
      Vue.set(state.data, key, data)
    },
    setLoaded(state, val) {
      state.loaded = val
    },
    resetData (state) {
      state.loaded = false
      state.data = {}
    }
  }
}
